import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericService } from '../generic.service';
import { ListaGeneralVistaModel } from '../../model/general/ListaGeneralVistaModel';
import { EnvconfigService } from '../envconfig.service';

@Injectable({
  providedIn: 'root'
})
export class GeneralService extends GenericService<ListaGeneralVistaModel> {

  constructor(protected override http: HttpClient,
    private enviroment: EnvconfigService) {
    super(http, `${enviroment.get("apiURL").trim()}/General`);
  }

  CargaListaDetalleDocumentos(request: ListaGeneralVistaModel): Observable<any> {
    const params = new HttpParams()
      .set('p_intIdSolicitud', request.intIdSolicitud?.toString())
      .set('p_intPageSize', request.p_intPageSize.toString())
      .set('p_intStartIndex', request.p_intStartIndex.toString())
      .set('p_vcCodigo', request.p_vcCodigo);
    return this.http.get(this.url + '/obtener-lista-archivos', { params });
  }

  CargaListaDetalleAuditoria(request: ListaGeneralVistaModel): Observable<any> {
    const params = new HttpParams()
      .set('p_intIdSolicitud', request.intIdSolicitud?.toString())
      .set('p_intPageSize', request.p_intPageSize.toString())
      .set('p_intStartIndex', request.p_intStartIndex.toString())
      .set('p_vcCodigo', request.p_vcCodigo);
    return this.http.get(this.url + '/obtener-historial-estados', { params });
  }

  InsertarCalificacion(request: any): Observable<any> {
    return this.http.post(this.url + '/registrar-nps', { Body: request });
  }

  ObtenerCalificacionUsuario(request: any): Observable<any> {
    const params = new HttpParams()
      .set('p_strUsuario', request.toString());
    return this.http.get(this.url + '/obtener-calificacion-usuario', { params });
  }

  obtenerTotalCalificacionesDestacadas(): Observable<any> {

    return this.http.get(`${this.url}/total-calificaciones-destacadas`);

  }

}
